/**
 * Czy przyjmujemy zgłoszenia dystrybutorów przez formularz.
 *
 * ═══ DZIŚ `false` — ŚWIADOMIE ═══
 * Formularz, model i powiadomienia są gotowe i przetestowane, ale obsługa
 * napływających zgłoszeń po naszej stronie jeszcze nie. Zgłoszenie, na które
 * nikt nie odpowie, jest gorsze niż jego brak: firma zapamięta, że pisała
 * i nikt się nie odezwał. Do tego czasu kierujemy na {@link ADRES_KONTAKTOWY}.
 *
 * ZANIM przestawisz na `true`, sprawdź to samo co przy wykonawcach:
 *   1. tabele `distributors` istnieją na produkcji (migracja + granty z
 *      `distributors/sql/grant_distributors_tables.sql`) — bez nich `POST
 *      /api/v1/distributors/apply` zwróci 500 przy pierwszym zgłoszeniu,
 *   2. `/health.json` → `email_configured: true`,
 *   3. `DISTRIBUTOR_NOTIFY_EMAIL` wskazuje CZYTANĄ skrzynkę.
 *
 * Flaga steruje DWOMA miejscami naraz — kafelkiem na `/dodaj-siebie`
 * i samą stroną `/zostan-dystrybutorem`. Przestawienie jej w jednym miejscu
 * zostawiłoby drugą drogę otwartą.
 */
// WŁĄCZONE 2026-08-10 po nadaniu grantów. Sprawdzone realnym zgłoszeniem na
// produkcji: `POST /api/v1/distributors/apply` -> 201 (wcześniej 500).
//
// Nauczka na przyszłość: 500 brało się z BRAKU GRANTÓW, nie z braku tabeli —
// `migrate distributors` mówiło „No migrations to apply", bo tabelę utworzył
// wcześniej psqladminun. Sama migracja nie wystarcza; użytkownik aplikacji
// potrzebuje osobnego nadania na każdą nową tabelę.
export const PRZYJMUJEMY_ZGLOSZENIA_DYSTRYBUTOROW = true

export default PRZYJMUJEMY_ZGLOSZENIA_DYSTRYBUTOROW
